// Configuration for Instagram graphic generator
export const CONFIG = {
  // Font sizes (in pixels)
  fontSizes: {
    headline: 76,
    headlineSmall: 62, // Smaller size for long headlines (>3 lines)
    subtitle: 48, // Subtitle text below headline
    category: 40,
    byline: 40,
    cta: 40, // "read at..." text
  },

  // Logo settings
  logo: {
    height: 55, // Logo height in pixels
  },

  // Category pill settings
  categoryPill: {
    cornerRadius: 10, // Corner radius for rounded rectangle
    padding: 15, // Horizontal padding inside pill
  },

  // Layout spacing
  spacing: {
    topPadding: 50,
    padding: 60, // Side padding
    headlineSpacing: 25, // Space between logo and headline
    subtitleSpacing: 20, // Space between headline and subtitle
    categorySpacing: 45, // Space between headline/subtitle and category
    ctaBottom: 80, // Space from bottom for CTA
  },

  // Line heights
  lineHeights: {
    headline: 88,
    headlineSmall: 72, // Proportional line height for smaller headline
  },
};

